import { ChangeDetectorRef, Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Amenity, Property, PropertyAmenity } from '../../models/property.model';
import { PropertyService } from '../../services/property.service';
import { switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { AmenityService } from '../../services/amenity.service';

@Component({
  selector: 'app-property-amenity-view',
  imports: [
    CommonModule,
    MatIconModule,
    MatChipsModule
  ],
  standalone: true,
  templateUrl: './property-amenity-view.html',
  styleUrl: './property-amenity-view.scss',
})
export class PropertyAmenityView implements OnInit, OnChanges {
  private propService = inject(PropertyService);
  private cdr = inject(ChangeDetectorRef);

  @Input() propertyId: string | undefined;
  @Input() inputProperty: Property | undefined;
  property: Property | undefined;
  amenityService = inject(AmenityService);
  error: string | null = null;
  amenities: Amenity[] = [];
  //categories: string[] = [ "Property Style", "Community Features", "Essential", "Comfort and Convenience", "Outdoor", "Waterfront and Boating", "Luxury and Recreation", "Family and Pet-Friendly", "Location-Specific", "Eco-Friendly and Smart", "Unique or Local", "Accessibility", "Safety and Practical"];
  categories: string[] = [];

  ngOnInit(): void {
    this.categories = this.amenityService.getAmenityCategories();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputProperty'] && changes['inputProperty'].currentValue) {
          this.property = changes['inputProperty'].currentValue;
          if (this.property && this.property.id) {
            this.getPropertyAmenities(this.property?.id);
          }
        }
  }

  getPropertyAmenities = (propertyId: string) => {
      this.propService.getAmenities().pipe(
        switchMap((amenities: Amenity[]) => {
          this.amenities = amenities;
          return this.propService.getPropertyAmenities(propertyId);
        })
      ).subscribe({
        next: (propertyAmenities: PropertyAmenity[]) => {
          // console.log('Received propertyAmenities:', propertyAmenities);
          // console.log('Current this.amenities:', this.amenities);
          // console.log('Current this.property:', this.property);
  
          if (this.property === null || this.property === undefined) {
            this.error = 'Property not found';
            this.cdr.detectChanges();
            return;
          }
  
          if (!this.amenities || this.amenities.length === 0) {
            this.error = 'No amenities available to filter';
            this.property.amenities = [];
            this.cdr.detectChanges();
            return;
          }
  
          if (propertyAmenities.length === 0) {
            this.property.amenities = [];
            this.error = 'No amenities associated with this property';
            this.cdr.detectChanges();
            return;
          }
  
          const propertyAmenityIds = new Set(propertyAmenities.map((pa) => pa.amenityId));
  
          this.property.amenities = this.amenities.filter((amenity) => {
            const isMatch = propertyAmenityIds.has(amenity.id);
            return isMatch;
          });
  
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('API Error:', error);
          this.error = 'Failed to load amenities or property amenities';
          this.cdr.detectChanges();
        },
      });
    };

  amenitiesByCategory = (category: string) => {
    if (this.property !== null) {
      return this.property?.amenities?.filter(p => p.category == category);
    } else {
      return [];
    }
  }

  getCategoryIcon(category: string) {
    return this.amenityService.getCategoryIcon(category);
  }
  // getCategoryIcon(category: string) {
  //   switch (category) {
  //     case "Property Style":
  //       return 'villa';          // or 'house' / 'apartment' / 'villa'
  //       break;
  //     case "Community Features":
  //       return 'park';           // or 'diversity_3' / 'people' / 'park'
  //       break;
  //     case "Waterfront and Boating":
  //       return 'directions_boat';
  //       break;
  //     case "Essential":
  //       return 'wifi'
  //       break;
  //     case "Comfort and Convenience":
  //       return 'ac_unit'
  //       break;
  //     case "Outdoor":
  //       return 'beach_access'
  //       break;
  //     case "Luxury and Recreation":
  //       return 'spa'
  //       break;
  //     case "Family and Pet-Friendly":
  //       return 'pets'
  //       break;
  //     case "Location-Specific":
  //       return 'local_activity'
  //       break;
  //     case "Eco-Friendly and Smart":
  //       return 'eco'
  //       break;
  //     case "Unique or Local":
  //       return 'public'
  //       break;
  //     case "Accessibility":
  //       return 'accessible'
  //       break;
  //     case "Safety and Practical":
  //       return 'security'
  //       break;
  //     default:
  //       return '';
  //   }
  // }
}
